import { shouldShowCWQALog } from "../../../utils/shouldShowCWQALog";

interface CWSubscribeParams {
  cwSubscribe: {
    subscription_id: string;
    customer_id: string;
    transaction_id: string;
    client_user_id: string;
    product_price: number;
    product_id: string;
    currency?: string;
  };
}

export const useCWsubscribe = ({ cwSubscribe }: CWSubscribeParams): void => {
  const eventData = {
    subscription_id: cwSubscribe.subscription_id,
    customer_id: cwSubscribe.customer_id,
    transaction_id: cwSubscribe.transaction_id,
    cw_client_user_id: cwSubscribe.client_user_id,
    payment_system: "solidgate",
    price: cwSubscribe.product_price,
    currency: cwSubscribe.currency ?? "USD",
    placement: "payment_form",
    intro_offer_product_id: cwSubscribe.product_id,
    product_id: cwSubscribe.product_id,
  };

  shouldShowCWQALog() && console.log(`cw_subscribe event`, eventData);
  window.gtag("event", "cw_subscribe", eventData);
};